// // This file is auto-generated by ./bin/rails stimulus:manifest:update

// Run that command whenever you add a new controller or create them with

// ./bin/rails generate stimulus controllerName

import { application } from './application'

import AccordionController from './accordion_controller'
import AjaxController from './ajax_controller'
import AutoSaveController from './auto_save_controller'
import ClickDataController from './click_data_controller'
import ClickToCopyController from './click_to_copy_controller'
import ColorPickerController from './color_picker_controller'
import ContactFormController from './contact_form_controller'
import CopyPreviousController from './copy_previous_controller'
import DateRangeDropdownController from './date_range_dropdown_controller'
import DragController from './drag_controller'
import EmailPanelsController from './email_panels_controller'
import FileDropzoneController from './file_dropzone_controller'
import FlashController from './flash_controller'
import FlatpickrInputController from './flatpickr_input_controller'
import GlanceColumnsController from './glance_columns_controller'
import GroupBuilderController from './group_builder_controller'
import LazyLoadController from './lazy_load_controller'
import LiveSearchController from './live_search_controller'
import MaskController from './mask_controller'
import ModalController from './modal_controller'
import PartyFormController from './party_form_controller'
import RecipientPreviewController from './recipient_preview_controller'
import ReportChartController from './report_chart_controller'
import ReportNoteModalController from './report_note_modal_controller'
import SearchController from './search_controller'
import SidebarController from './sidebar_controller'
import SortingController from './sorting_controller'
import TimeOnPageController from './time_on_page_controller'
import TooltipController from './tooltip_controller'
import VideoController from './video_controller'

application.register('accordion', AccordionController)
application.register('ajax', AjaxController)
application.register('auto-save', AutoSaveController)
application.register('click-data', ClickDataController)
application.register('click-to-copy', ClickToCopyController)
application.register('color-picker', ColorPickerController)
application.register('contact-form', ContactFormController)
application.register('copy-previous', CopyPreviousController)
application.register('date-range-dropdown', DateRangeDropdownController)
application.register('drag', DragController)
application.register('email-panels', EmailPanelsController)
application.register('file-dropzone', FileDropzoneController)
application.register('flash', FlashController)
application.register('flatpickr-input', FlatpickrInputController)
application.register('glance-columns', GlanceColumnsController)
application.register('group-builder', GroupBuilderController)
application.register('lazy-load', LazyLoadController)
application.register('live-search', LiveSearchController)
application.register('mask', MaskController)
application.register('modal', ModalController)
application.register('party-form', PartyFormController)
application.register('recipient-preview', RecipientPreviewController)
application.register('report-chart', ReportChartController)
application.register('report-note-modal', ReportNoteModalController)
application.register('search', SearchController)
application.register('sidebar', SidebarController)
application.register('sorting', SortingController)
application.register('time-on-page', TimeOnPageController)
application.register('tooltip', TooltipController)
application.register('video', VideoController)
